import { render, staticRenderFns } from "./FieldtypeSelector.vue?vue&type=template&id=4b9703d4&"
import script from "./FieldtypeSelector.vue?vue&type=script&lang=js&"
export * from "./FieldtypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports